module.exports = __webpack_public_path__ + "img/additional_btn.9fb45c45.png";